<template>
  <div class="about">
    <h1>用户注册</h1>
  </div>
</template>
